import { idtype } from "querypieces";

export default `
  ...on pageBuilder_partnerList_BlockType {
    ${idtype}
    heading
  }
`;
